/* eslint-disable */

// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_project_region: "us-east-2",
  aws_cognito_identity_pool_id:
    "us-east-2:1a86a57c-ebe4-4180-8d6c-9acb5d83034d",
  aws_cognito_region: "us-east-2",
  aws_user_pools_id: "us-east-2_BXG9ldR40",
  aws_user_pools_web_client_id: "3a5rridckb85obdek4fc7dcffl",
  oauth: {},
  aws_cognito_username_attributes: ["EMAIL"],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ["EMAIL"],
  aws_cognito_mfa_configuration: "OFF",
  aws_cognito_mfa_types: ["SMS"],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ["EMAIL"],
};
export default awsmobile;
